import React, { useContext, useEffect, useState } from "react";
import "../../assets/AdminCss/card.css";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { AuthContext, base_url } from "../../context/Authcontext";
import LoginReg from "../LoginReg";

const FeaturedCard = ({ background, idxx, aviator }) => {
  // console.log('feature calledd', idxx, aviator);
  const navigate= useNavigate();
  const [active, setactive] = useState(false);
  const [regactive, setregactive] = useState(false);

  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
      const token= localStorage.getItem('game_token');
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please Login to Play.');
          setactive(true);
        }


    }catch(err){
        console.log(err);
    }
  }

  const handleClick= (idxx)=>{
    if (idxx===0){
      navigate('/casinoGames');
    }else if(idxx===1){
      navigate('/cricketreal');
    }else if(idxx===2){
        if (aviator) {
          openGameById(aviator);
        } else {
          toast.error('Aviator game is not available yet.');
        }
    }else if(idxx===3){
      navigate('/virtual');
    }
  }

  


  return (
    <>
    {<LoginReg active={active} setactive={setactive} regactive={regactive} setregactive={setregactive}/>}
    <div
      className="rounded-xl wide-card position-relative"
        onClick={()=>handleClick(idxx)}
      style={{
        background: background,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: "100%",
        height: "0",
        overflow: "hidden",
        margin: "5px",
        paddingBottom: "38.25%",
      }}
    >
      <div
        className="position-absolute"
        style={{ bottom: "10px", left: "10px" }}
      >
        <span
          className="bg-warning text-dark px-2 py-1 rounded-pill"
          style={{ fontSize: "12px", fontWeight: "bold" }}
        >
          Popular
        </span>
      </div>
    </div>
    </>
  );
};


const handlepopup = () => {
  toast.success("coming Soon");
};



const CategoryCard = ({ title, background, icon, url, isWide = false, tab }) => {
  const navigate = useNavigate();
  const [active, setactive]= useState(false);
  const { isAuthenticated }= useContext(AuthContext);

  const handleSubmit= async()=>{
    const token=localStorage.getItem('game_token');
    try{
      const response= await axios.post(base_url + '/api/webapi/casinoLobby',{token},
        {
          withCredentials:true,
          headers:{
            'content-type':'application/json',
          }
        }
      )
  
      // console.log('lobby',response);
      if(response?.data.success){
        window.location.href=response?.data.url;
      }else{
        toast.error(response?.data.message);
      }
  
    }catch(err){
      console.log(err);
    }
  }

  const handleCasino = (route) => {
    // console.log('route', route);
    if (route === 1) {
      if(isAuthenticated){
        toast.success("Redirection to lobby..");
        handleSubmit();
      }else{
        toast.error('Login to play casino');
        setactive(true);
      }
    } else {
      navigate('/casinoGames', { state: { list: route } });
    }
  };

  const handleClick = () => {
    if (url) {
      navigate(url);
    } else if (tab !== undefined) {
      handleCasino(tab);
    }
  };

  return (
    <>
    {<LoginReg active={active} setactive={setactive} />}
    <div
      className={`rounded-lg p-1 d-flex items-center gap-3 w-100 ${
        isWide ? "col-span-2" : ""
      }`}
      style={{
        background: background,
        backgroundSize:
          isWide && background.startsWith("url") ? "contain" : "auto",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        width: isWide ? "1172px" : "auto",
      }}
      onClick={handleClick}
    >
      <div className="text-white font-bold text-lg p-2">{title}</div>
      <div className="text-white ml-sm-auto mt-sm-2">
        {typeof icon === "string" ? (
          <img
            src={icon}
            alt={title}
         
            height="20"
            className="w-6 h-6"
          />
        ) : (
          icon
        )}
      </div>
    </div>
    </>
  );
};

const CategoryGrid = () => {
  // console.log('catigory called');
  const navigate= useNavigate();
  const [active, setactive] = useState(false);
  const [regactive, setregactive] = useState(false);
  const [aviator, setAviator]= useState();


  const handleAviator= async()=>{
    try{
      const token=localStorage.getItem('game_token');
      const response = await axios.get(base_url + '/api/webapi/particularGame', {
        params:{
          token,
          provider:'SPB',
        },
        withCredentials: true,
        headers: {
          'content-type': 'application/json',
        },
      });
      // console.log('games',response?.data);
      const games= response?.data?.items;

      const avia= games?.filter(game=>game?.name.includes('Aviator'));
      // console.log('aviator',avia[0]);
      const id=avia[0]?.id;
      setAviator(id);

    }catch(err){
      console.log(err);
    }
  }


  const openGameById= async(gameId)=>{
    // console.log('id',gameId);
    try{
      const token= localStorage.getItem('game_token');
        const response= await axios.post(base_url + '/api/gamelaunch/url',
            {token, gameId},
            {
                withCredentials:true,
                headers:{
                    'content-type':'application/json',
                }
            }
        )

        // console.log('url response',response);
        if(response?.data.success){
        const url=response?.data.url;
        window.location.href=url;

        }else{
          toast.error('Please Login to Play.');
          setactive(true);
        }


    }catch(err){
        console.log(err);
    }
  }

  const sportsCategories = [
    {
      title: "Cricket",
      background: "linear-gradient(270deg, #c435ef 0%, #662ef3 100%)",
      icon: "/assets/all_images/grid/g1.png",
      route: "/cricketreal",
    },
    {
      title: "Football",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g2.png",
      route: "/footballreal",
    },
    {
      title: "Tennis",
      background: "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
      icon: "/assets/all_images/grid/g3.png",
      route: "/tennisreal",
    },
    {
      title: "Horse Racing ",
      background: "#EC4899",
      icon: "/assets/all_images/grid/g4.png",
    },
    {
      title: "GreyHound",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g5.png",
    },
  ];

  const casinoCategories = [
    {
      title: "Casino Lobby",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g6.png",
      tab:1
    },
    {
      title: "Teen Patti",
      background: "#EC4899",
      icon: "/assets/all_images/grid/g7.png",
      tab:4
    },
    {
      title: "Table Games",
      background: "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
      icon: "/assets/all_images/grid/g8.png",
      tab:18
    },
    {
      title: "Live Casino",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g23.png",
      tab:7
    },
    {
      title: "Crash Games",
      background: "#EC4899",
      icon: "/assets/all_images/grid/g9.png",
      tab:11
    },
    {
      title: "Teen Patti",
      background: "linear-gradient(91deg, #f7a545 0.66%, #d8560c 99.47%)",
      icon: "/assets/all_images/grid/g10.png",
      tab:4
    },
    {
      title: "Slot Games",
      background: "linear-gradient(91deg, #07abd0 0.66%, #95d7e6 99.47%)",
      icon: "/assets/all_images/grid/g11.png",
      tab:16
    },
  ];

  const featuredCategories = [
    {
      title: "NEW INDIAN CASINO",
      background: 'url("/assets/all_images/grid/g12.png")',
      icon: "🇮🇳",
      isWide: true,
      route:1
    },
    {
      title: "INDIAN PREMIER LEAGUE",
      background: 'url("/assets/all_images/grid/g13.png")',
      icon: "🏏",
      isWide: true,
      route:2
    },
    {
      title: "PLAY AVIATOR",
      background: 'url("	/assets/all_images/grid/g14.png")',
      icon: "✈",
      isWide: true,
      route:3
    },
    {
      title: "VIRTUAL CRICKET",
      background: 'url("/assets/all_images/grid/g15.png")',
      icon: "🏏",
      isWide: true,
      route:4
    },
  ];

  const featuredBackgrounds = [
    'url("https://dabba.b-cdn.net/kheloyaar360.net/banners/36648.png")',
    'url("/assets/all_images/grid/g13.png")',
    'url("https://dabba.b-cdn.net/kheloyaar360.net/banners/36649.png")',
    'url("https://dabba.b-cdn.net/kheloyaar360.net/banners/36647.png")',
  ];

  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth < 768);
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);
    handleAviator();

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
    {<LoginReg active={active} setactive={setactive} regactive={regactive} setregactive={setregactive}/>}
    <div className=" mx-auto">


      {/* Sports Categories */}
      {/* Sports Categories */}
      <div className="flex flex-row gap-1 overflow-x-auto text-nowrap cursor-pointer responsive-sports mb-2">
        {sportsCategories.map((category, index) => (
          <CategoryCard
            key={`sports-${index}`}
            title={category.title}
            background={category.background}
            icon={category.icon}
            url={category.route}
          />
        ))}
      </div>



      {/* Casino Categories */}
      <div
        className="flex flex-row gap-2 overflow-x-auto text-nowrap cursor-pointer"
      >
        {casinoCategories.map((category, index) => (
          
          <CategoryCard
            key={`casino-${index}`}
            title={category.title}
            background={category.background}
            icon={category.icon}
            tab={category.tab}
          />
        ))}
      </div>




      {/* Featured Categories */}
      <div
        className="d-flex overflow-auto gap-1 pt-2"
        style={{ whiteSpace: "nowrap" }}
      >
        {featuredCategories.map((category, index) => {
          const imageUrl = category.background
            .replace(/^url\(["']?/, "")
            .replace(/["']?\)$/, "");

            const handleClick = (route) => {
              // console.log('route', route);
              switch (route) {
                case 1:
                  navigate('/casinoGames');
                  break;
                case 2:
                  navigate('/sportAll');
                  break;
                case 3:
                  if (aviator) {
                    openGameById(aviator);
                  } else {
                    toast.error('Aviator game is not available yet.');
                  }
                  break;
                case 4:
                  toast.success('Coming Soon');
                  break;
                default:
                  break;
              }
            };
            

          return (
            <div
              key={`featured-cat-${index}`}
              className={`${
                isTablet ? "d-none" : "d-inline-flex"
              } align-items-center justify-content-between position-relative pointer me-2`}
              style={{ minWidth: "150px" }}
              onClick={()=>handleClick(category.route)}
            >
              <img
                src={imageUrl}
                alt={category.title}
                className="img-fluid rounded"
                loading="lazy"
              />
            </div>
          );
        })}
      </div>

      <div className="row g-2  hidee  row1">
        {featuredBackgrounds.map((background, index) => (
          <div key={`featured-${index}`} className="col-6 mb-1">
            <FeaturedCard background={background} idxx={index} aviator={aviator} />
          </div>
        ))}
      </div>
    </div>
    </>
  );
};

export default CategoryGrid;